import type { ReactNode } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";
import { Box, Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { StyledDataItemHeader } from "app/pages/sales-intelligence/pages/company-analysis/containers/overview/CompanyData/styles";
import type { FieldAnnotation } from "app/pages/sales-intelligence/pages/company-analysis/containers/overview/CompanyData/utils";

type Props = {
    title: string;
    badge: ReactNode;
    value: string | number | undefined | null;
    annotation?: FieldAnnotation;
    fieldKey: string;
};

export const CompanyDataItem = ({ title, badge, annotation, value, fieldKey }: Props) => {
    const titleElement = (
        <StyledDataItemHeader
            fontVariant="caption"
            color={colorsPalettes.carbon[250]}
            margin="0 0 4px 0"
            display="block"
        >
            {title}
        </StyledDataItemHeader>
    );

    return (
        <Box data-automation={fieldKey}>
            {badge ? (
                <Flex
                    gap="8px"
                    alignItems="baseline"
                >
                    {titleElement} {badge}
                </Flex>
            ) : (
                titleElement
            )}

            <Flex
                alignItems="center"
                gap="4px"
                justifyContent="flex-start"
            >
                <Text
                    fontVariant="body1"
                    color={colorsPalettes.carbon[500]}
                    flex="0 0 auto"
                >
                    {value || translate("si.common.na")}
                </Text>

                {annotation ? (
                    <Tooltip content={annotation.content}>
                        <SWReactIcons
                            iconName={annotation.iconName}
                            size="xs"
                        />
                    </Tooltip>
                ) : null}
            </Flex>
        </Box>
    );
};
